import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseUserPollManagment() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      orderType: isEmpty(state.orderType),
      question: isEmpty(state.question),
    };
    setter(errorState);

    if (errorState.orderType || errorState.question) {
      enqueueSnackbar("لطفا اطلاعات نظرسنجی را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetUserPoll = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ManageUserPoll?w=${search}`, {
      headers: {
        IsPage: bool ? true : false,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetUserPollById = (pollId, callback) => {
    MyAxios.get(`Admin_ManageUserPoll/${pollId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const UpdateUserPoll = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_ManageUserPoll`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const AddUserPoll = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ManageUserPoll`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("باموفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteUserPoll = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_ManageUserPoll`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  return {
    validate,
    GetUserPoll,
    GetUserPollById,
    UpdateUserPoll,
    AddUserPoll,
    deleteUserPoll,
    GetUserPollById,
  };
}
